<template>
<div class="chapter">
<div class="inner_page">
<h1>CONTENTS</h1>
<p class="toct"><span href="#/xhtml/06chapter02#ch1" title="Link target outside of Sample">THE GARDENER SAYS</span></p>
<p class="toc"><span href="#/xhtml/07index#ind" title="Link target outside of Sample">INDEX</span></p>
<p class="toc"><span href="#/xhtml/08acknowledgments#ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04toc.vue?3ab0a6d5